import Head from 'next/head'
import { useMachine } from '@xstate/react'
import { useRouter } from 'next/router'
import productPageMachine from '../product-page-machine'
import SEO from '../components/SEO/seo'
import Sections from '../components/Sections/sections'
import ProductHero from '../components/ProductHero/product-hero'
import JSONSchema from '../components/JSONSchema/json-schema'
import useTranslations from '../utils/use-translations'
import useDiscountSettings from '../utils/use-discount-settings'

const navigateToOrder = (router) => (ctx) => {
  const { orderJourneyUrl } = ctx
  router.push(orderJourneyUrl)
}

const ProductPage = ({ page }) => {
  const router = useRouter()
  const translations = useTranslations()
  const discountSettings = useDiscountSettings()
  const currency = 'GBP'
  const checkboxes = page?.data?.component === 'checkbox'
  const hasMultiplePrices = page?.data?.hasMultiplePrices[currency]

  const [current, send] = useMachine(productPageMachine, {
    context: {
      locale: router.locale,
      hasMultiplePrices: hasMultiplePrices || false,
      currency: 'GBP',
      product: page.data,
      orderJourney: page?.orderJourney,
      orderJourneyUrl: '',
      referrer: router.asPath,
      checkboxes,
      beforePriceText: translations['productPage.beforePriceText'],
      orderButtonText: translations['productPage.orderButtonText'],
      oosOrderButtonText: translations.outOfStock,
      discountSettings,
    },
    actions: {
      navigateToOrder: navigateToOrder(router),
    },
  })

  return (
    <>
      {page.jsonSchema && <JSONSchema id={page.id} schema={page.jsonSchema} />}
      {page.seo && <SEO seo={page.seo} url={page.url} Head={Head} />}
      {page && (
        <ProductHero
          productPage={page}
          context={current.context}
          send={send}
        />
      )}
      {page.sections && <Sections sections={page.sections} />}
    </>
  )
}

export default ProductPage
